import React, {ComponentProps} from 'react';
import cn from 'classnames';

import Grid from '@material-ui/core/Grid';
import {makeStyles} from '@material-ui/core/styles';

export const GridBordered: React.FC<ComponentProps<typeof Grid>> = ({
  children,
  className,
  ...props
}) => {
  const {wrap} = useStyles();
  return (
    <Grid item {...props}>
      <div className={cn(wrap, className)}>{children}</div>
    </Grid>
  );
};

const useStyles = makeStyles(() => ({
  wrap: {
    border: '1px solid #CCCCCC',
    borderRadius: 3,
    boxSizing: 'border-box',
    height: '100%',
  },
}));
